/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarCupomDiscussaoDto,
  CriarCupomDiscussaoDto,
  CupomDiscussaoResponse,
  CuponsDiscussaoAdminControllerListarParams,
  CuponsDiscussaoAdminControllerListarUsosParams,
  ErroResponse,
  PaginaDeCuponsDiscussaoResponse,
  PaginaDeUsosDeCupomResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCuponsDiscussaoAdminControllerListarUrl = (params?: CuponsDiscussaoAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/cupons-discussao?${stringifiedParams}` : `/v1/admin/cupons-discussao`
}

/**
 * @summary Lista os cupons de desconto da discussão técnica, paginado
 */
export const cuponsDiscussaoAdminControllerListar = async (params?: CuponsDiscussaoAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCuponsDiscussaoResponse> => {

  return httpClient<PaginaDeCuponsDiscussaoResponse>(getCuponsDiscussaoAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCuponsDiscussaoAdminControllerListarQueryKey = (params?: CuponsDiscussaoAdminControllerListarParams,) => {
    return [
    `/v1/admin/cupons-discussao`, ...(params ? [params] : [])
    ] as const;
    }


export const getCuponsDiscussaoAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError = ErroResponse>(params?: CuponsDiscussaoAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCuponsDiscussaoAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>> = ({ signal }) => cuponsDiscussaoAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CuponsDiscussaoAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>>
export type CuponsDiscussaoAdminControllerListarQueryError = ErroResponse


export function useCuponsDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  CuponsDiscussaoAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError = ErroResponse>(
 params?: CuponsDiscussaoAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError = ErroResponse>(
 params?: CuponsDiscussaoAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os cupons de desconto da discussão técnica, paginado
 */

export function useCuponsDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError = ErroResponse>(
 params?: CuponsDiscussaoAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCuponsDiscussaoAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCuponsDiscussaoAdminControllerCriarUrl = () => {




  return `/v1/admin/cupons-discussao`
}

/**
 * @summary Cria um cupom de desconto
 */
export const cuponsDiscussaoAdminControllerCriar = async (criarCupomDiscussaoDto: CriarCupomDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomDiscussaoResponse> => {

  return httpClient<CupomDiscussaoResponse>(getCuponsDiscussaoAdminControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarCupomDiscussaoDto)
  }
);}





export const getCuponsDiscussaoAdminControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerCriar>>, TError,{data: CriarCupomDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerCriar>>, TError,{data: CriarCupomDiscussaoDto}, TContext> => {

const mutationKey = ['cuponsDiscussaoAdminControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerCriar>>, {data: CriarCupomDiscussaoDto}> = (props) => {
          const {data} = props ?? {};

          return  cuponsDiscussaoAdminControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuponsDiscussaoAdminControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerCriar>>>
    export type CuponsDiscussaoAdminControllerCriarMutationBody = CriarCupomDiscussaoDto
    export type CuponsDiscussaoAdminControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um cupom de desconto
 */
export const useCuponsDiscussaoAdminControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerCriar>>, TError,{data: CriarCupomDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerCriar>>,
        TError,
        {data: CriarCupomDiscussaoDto},
        TContext
      > => {
      return useMutation(getCuponsDiscussaoAdminControllerCriarMutationOptions(options), queryClient);
    }
    export const getCuponsDiscussaoAdminControllerObterUrl = (id: string,) => {




  return `/v1/admin/cupons-discussao/${id}`
}

/**
 * @summary Detalha um cupom
 */
export const cuponsDiscussaoAdminControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CupomDiscussaoResponse> => {

  return httpClient<CupomDiscussaoResponse>(getCuponsDiscussaoAdminControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCuponsDiscussaoAdminControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/cupons-discussao/${id}`
    ] as const;
    }


export const getCuponsDiscussaoAdminControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCuponsDiscussaoAdminControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>> = ({ signal }) => cuponsDiscussaoAdminControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CuponsDiscussaoAdminControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>>
export type CuponsDiscussaoAdminControllerObterQueryError = ErroResponse


export function useCuponsDiscussaoAdminControllerObter<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsDiscussaoAdminControllerObter<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsDiscussaoAdminControllerObter<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um cupom
 */

export function useCuponsDiscussaoAdminControllerObter<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCuponsDiscussaoAdminControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCuponsDiscussaoAdminControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/cupons-discussao/${id}`
}

/**
 * @summary Atualiza o cupom — `{ ativo: false }` é a forma de "excluir"
 */
export const cuponsDiscussaoAdminControllerAtualizar = async (id: string,
    atualizarCupomDiscussaoDto: AtualizarCupomDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomDiscussaoResponse> => {

  return httpClient<CupomDiscussaoResponse>(getCuponsDiscussaoAdminControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarCupomDiscussaoDto)
  }
);}





export const getCuponsDiscussaoAdminControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerAtualizar>>, TError,{id: string;data: AtualizarCupomDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerAtualizar>>, TError,{id: string;data: AtualizarCupomDiscussaoDto}, TContext> => {

const mutationKey = ['cuponsDiscussaoAdminControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerAtualizar>>, {id: string;data: AtualizarCupomDiscussaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cuponsDiscussaoAdminControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuponsDiscussaoAdminControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerAtualizar>>>
    export type CuponsDiscussaoAdminControllerAtualizarMutationBody = AtualizarCupomDiscussaoDto
    export type CuponsDiscussaoAdminControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Atualiza o cupom — `{ ativo: false }` é a forma de "excluir"
 */
export const useCuponsDiscussaoAdminControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerAtualizar>>, TError,{id: string;data: AtualizarCupomDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarCupomDiscussaoDto},
        TContext
      > => {
      return useMutation(getCuponsDiscussaoAdminControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCuponsDiscussaoAdminControllerListarUsosUrl = (id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/cupons-discussao/${id}/usos?${stringifiedParams}` : `/v1/admin/cupons-discussao/${id}/usos`
}

/**
 * @summary Quem usou este cupom, quando e em qual discussão — pro suporte responder sem consultar o banco
 */
export const cuponsDiscussaoAdminControllerListarUsos = async (id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeUsosDeCupomResponse> => {

  return httpClient<PaginaDeUsosDeCupomResponse>(getCuponsDiscussaoAdminControllerListarUsosUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCuponsDiscussaoAdminControllerListarUsosQueryKey = (id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams,) => {
    return [
    `/v1/admin/cupons-discussao/${id}/usos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCuponsDiscussaoAdminControllerListarUsosQueryOptions = <TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError = ErroResponse>(id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCuponsDiscussaoAdminControllerListarUsosQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>> = ({ signal }) => cuponsDiscussaoAdminControllerListarUsos(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CuponsDiscussaoAdminControllerListarUsosQueryResult = NonNullable<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>>
export type CuponsDiscussaoAdminControllerListarUsosQueryError = ErroResponse


export function useCuponsDiscussaoAdminControllerListarUsos<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError = ErroResponse>(
 id: string,
    params: undefined |  CuponsDiscussaoAdminControllerListarUsosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>,
          TError,
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsDiscussaoAdminControllerListarUsos<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError = ErroResponse>(
 id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>,
          TError,
          Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsDiscussaoAdminControllerListarUsos<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError = ErroResponse>(
 id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quem usou este cupom, quando e em qual discussão — pro suporte responder sem consultar o banco
 */

export function useCuponsDiscussaoAdminControllerListarUsos<TData = Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError = ErroResponse>(
 id: string,
    params?: CuponsDiscussaoAdminControllerListarUsosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsDiscussaoAdminControllerListarUsos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCuponsDiscussaoAdminControllerListarUsosQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






